import _ from 'lodash';
import classnames from 'classnames';
import { faPlane } from '@fortawesome/pro-solid-svg-icons/faPlane';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import { FlightTransactionDef } from 'models/configuration/transaction_def';

export const FlightAttributesPropTypes = PropTypes.shape({
  // Required attributes
  departureTime: PropTypes.string, // Ought to be required but 🤫
  destination: PropTypes.string.isRequired,
  flightNumber: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired,
  pnrCode: PropTypes.string.isRequired,
  status: PropTypes.string,
});

export default function ExpandedFlightTransactionHeader({ attributes, transactionDef }) {
  const departureDate = attributes.departureTime ? moment(attributes.departureTime).format('MMM D YYYY') : '';
  const departureTime = attributes.departureTime ? moment(attributes.departureTime).format('hh:mm A') : '';

  const headerClassNames = classnames('flightTransaction-expandedInformation-header', {
    'flightTransaction-expandedInformation-header-withoutDepartureTime': !attributes.departureTime,
    'flightTransaction-expandedInformation-header-noOptionalAttributes': !_.some(
      _.map(transactionDef.attributes, def => attributes[def.attr])
    ),
  });

  return (
    <div className={headerClassNames}>
      <div className="flightTransaction-expandedInformation-header-left">
        <div className="flightTransaction-expandedInformation-header-origin">
          <div className="flightTransaction-expandedInformation-header-originCode">{attributes.origin}</div>
          <div className="flightTransaction-expandedInformation-header-flightIcon">
            <FontAwesomeIcon icon={faPlane} />
          </div>
        </div>
        <div className="flightTransaction-expandedInformation-header-departureDate">{departureDate}</div>
        <div className="flightTransaction-expandedInformation-header-departureTime">{departureTime}</div>
      </div>
      <div className="flightTransaction-expandedInformation-header-right">
        <div className="flightTransaction-expandedInformation-header-destination">{attributes.destination}</div>
      </div>
    </div>
  );
}

ExpandedFlightTransactionHeader.propTypes = {
  attributes: FlightAttributesPropTypes.isRequired,
  transactionDef: PropTypes.instanceOf(FlightTransactionDef).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/transactions/expanded_flight_transaction.jsx